// Identity of one row of the combined Wallet statement. The two rows of one
// movement (both sides of a Savings move, or a receipt split between Current
// and Savings) may share an entryRef, so the account and direction are part
// of the identity.
export const walletStatementEntryKey = (entry) =>
  `${entry.entryRef}:${entry.account}:${entry.direction}`;
